import { Protocol } from '../Protocol';

export class ExptScheduleProtocol {
  public static readonly EXPT_SCHEDULE_BY_ID: string = `${Protocol.YATUNG_API_ROOT}/schedule`;
  public static readonly PAGEABLE_EXPT_SCHEDULE_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/schedule/p/all`;
}
